/**
 * @file Content Bar.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Content Bar component.
 */
const vContentBar = () => {
	const contentBar = document.querySelector('.v-content-bar');

	if (!contentBar) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	ScrollTrigger.matchMedia({
		'(min-width: 1025px)': () => {
			gsap.to('.v-content-bar__bar', {
				'--clip':      '0%',
				ease:          'sine.out',
				scrollTrigger: {
					trigger: '.v-content-bar__bar',
					start:   'top bottom',
					end:     'bottom center',
					scrub:   true,
				},
			});
		},
	});
};

export default vContentBar;
